<mdb-card narrower="true" cascade="true">
    <div class="row">
        <div class="col-md-6">
            <app-card-header [headingSize]="2" [title]="formTitle">
            </app-card-header>
        </div>
    </div>
    <mdb-card-body cascade="true">

        <div class="row">
            <div class="col-md-12">
                <app-form-input [vm]="vm" (textChanged)="textChanged(vm, $event)"></app-form-input>
            </div>
        </div>

        <app-form-ok-cancel [vm]="vmOkCancel" (okClicked)="ok(vm)" (cancelClicked)="cancel(vm)"
            [isInvalid]="isInvalid"></app-form-ok-cancel>

    </mdb-card-body>
</mdb-card>